function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import DropdownWrapper from '../dropdown-wrapper';
import Menu from './menu';
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
export const Select = ({
  value,
  options,
  onChange,
  placeholder,
  label,
  hint,
  errorMessage,
  searchable = false,
  maxHeight = 0,
  size = 'md',
  hideLabel = false,
  smallLabel = false,
  disabled = false,
  allowReset = false,
  showContext = true,
  joyableTheme = false,
  closedIcon = 'ChevronUp',
  openedIcon = 'ChevronDown',
  iconColor = 'gray700',
  ...props
}) => {
  const initialValue = options.find(option => {
    if (typeof value === 'object') {
      return JSON.stringify(option.value) === JSON.stringify(value);
    }
    return option.value === value;
  });
  const selectionChanged = ({
    value
  }) => onChange(value);
  const itemToString = item => item ? item.label : '';
  const getMenuOptions = (inputValue, selectedItem, highlightedIndex, getItemProps, ariaLabel) => {
    return options.filter(option => !searchable || !inputValue || option.label.toLowerCase().includes(inputValue.toLowerCase())).map((option, index) => {
      return {
        ...option,
        props: getItemProps({
          key: `${option.value}${index}`,
          item: option,
          ariaLabel,
          index,
          hovered: index === highlightedIndex,
          selected: JSON.stringify(option) === JSON.stringify(selectedItem)
        })
      };
    });
  };
  return /*#__PURE__*/React.createElement(DropdownWrapper, _extends({
    initialValue: initialValue,
    clearOnFocus: searchable,
    readOnly: !searchable,
    allowReset: allowReset,
    onChange: selectionChanged,
    itemToString: itemToString,
    joyableTheme: joyableTheme,
    closedIcon: closedIcon,
    openedIcon: openedIcon,
    iconColor: iconColor,
    label,
    placeholder,
    hint,
    size,
    errorMessage,
    hideLabel,
    smallLabel,
    disabled
  }, props, {
    renderChildren: ({
      inputValue,
      selectedItem,
      highlightedIndex,
      ariaLabel,
      getItemProps,
      getMenuProps
    }) => /*#__PURE__*/React.createElement(Menu, {
      inputValue: inputValue,
      searchable: searchable,
      maxHeight: maxHeight,
      size: size,
      items: getMenuOptions(inputValue, selectedItem, highlightedIndex, getItemProps, ariaLabel),
      menuProps: getMenuProps(),
      showContext: showContext,
      joyableTheme: joyableTheme
    })
  }));
};
export default Select;
//# sourceMappingURL=index.js.map